import script from "./ContributorLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorLeaderboard.vue?vue&type=script&setup=true&lang=js"

import "./ContributorLeaderboard.vue?vue&type=style&index=0&id=25847da7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25847da7"]])

export default __exports__